/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function pay(params, context) {
    var formatInput = function (options) { return ({
        orderStr: options.payStr,
    }); };
    context === null || context === void 0 ? void 0 : context.WVCall('CNHybridAliPay.openAlipay', params, {
        formatInput: formatInput,
    });
}

export { pay as default };
